export function normalizeAddress(address: string, prefix = '0x') {
    return address.startsWith(prefix) ? address : `${prefix}${address}`;
}

// TODO: This function is deprecated in favour of `truncateContractAddress()`.
export function getShortWalletAddress(address: string) {
    const addressDivisionIndex = 5;
    const suffixStartIndex = address.length - (addressDivisionIndex - 1);
    const suffixEndIndex = address.length;

    const shortAddressParts = [
        address.substring(0, addressDivisionIndex),
        '…',
        address.substring(suffixStartIndex, suffixEndIndex),
    ];

    return shortAddressParts.join('');
}

export function truncateContractAddress(value = '') {
    const prefixLength = 6;
    const suffixLength = 4;

    const segments = [value.slice(0, prefixLength), '…', value.slice(suffixLength * -1)];

    return value.length > prefixLength + suffixLength ? segments.join('') : value;
}
